// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*/********** opt container start /***********/
.optContainer input {
    width: 60px !important;
    height: 60px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    border: 1px solid var(--primary-border);
    color: var(--primary-foreground);
    background: var(--primary-input-bg);
    border-radius: var(--radius-1);
    outline: none;
}

.optContainer {
    max-width: 320px;
    margin: 0 auto;
}

.optContainer>div {
    justify-content: center;
    gap: 18px;
    grid-gap: 18px;
}

.optNumberContainer {
    margin-top: 24px;
    text-align: center;
}

.optNumberWrapper {
    background: var(--opt-bg);
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: var(--common-primary-black-foreground);
    padding: 6px 12px;
    display: inline-block;
    border-radius: 30px;
    cursor: pointer;
}

.optResendContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 16px;
    line-height: 26px;
    gap: 6px;
    grid-gap: 6px;
    text-align: center;
    margin-top: 24px;
}

.optResendText {
    font-weight: 600;
    color: var(--primary-foreground);
}


@media (max-width: 374px) {
    .optContainer input {
        width: 45px !important;
        height: 45px;
    }
}

.rtl .optContainer {
    text-align: left !important;
    direction: ltr !important;
}

/*/********** opt container end /***********/`, "",{"version":3,"sources":["webpack://./src/styles/optInput.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,gCAAgC;IAChC,mCAAmC;IACnC,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;;AAGA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,4CAA4C","sourcesContent":["/*/********** opt container start /***********/\n.optContainer input {\n    width: 60px !important;\n    height: 60px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    border: 1px solid var(--primary-border);\n    color: var(--primary-foreground);\n    background: var(--primary-input-bg);\n    border-radius: var(--radius-1);\n    outline: none;\n}\n\n.optContainer {\n    max-width: 320px;\n    margin: 0 auto;\n}\n\n.optContainer>div {\n    justify-content: center;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.optNumberContainer {\n    margin-top: 24px;\n    text-align: center;\n}\n\n.optNumberWrapper {\n    background: var(--opt-bg);\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 600;\n    color: var(--common-primary-black-foreground);\n    padding: 6px 12px;\n    display: inline-block;\n    border-radius: 30px;\n    cursor: pointer;\n}\n\n.optResendContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    font-size: 16px;\n    line-height: 26px;\n    gap: 6px;\n    grid-gap: 6px;\n    text-align: center;\n    margin-top: 24px;\n}\n\n.optResendText {\n    font-weight: 600;\n    color: var(--primary-foreground);\n}\n\n\n@media (max-width: 374px) {\n    .optContainer input {\n        width: 45px !important;\n        height: 45px;\n    }\n}\n\n.rtl .optContainer {\n    text-align: left !important;\n    direction: ltr !important;\n}\n\n/*/********** opt container end /***********/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
